import { usePrevRoute } from "hooks/usePrevRoute";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { actions as creditBillActions } from "reducers/creditBills";
import { filterByTabList, initialFilters, monedas } from "util/creditBills";

export const useBills = ({ positionTab, tabOption }) => {
    const [summaryData, setSummaryData] = useState([]);
    const dispatch = useDispatch();
    const { state = { tab: 0 } } = useLocation();
    const { fromOtherPage, fromPage: fromCreditBillsPage } = usePrevRoute("creditBills");
    const { filters, creditBillList, fetching } = useSelector((_state) => _state.creditBills);

    const fetchMoreBills = useCallback(
        (pageNumber) => {
            dispatch(creditBillActions.getCreditBills({ ...filters, pageNumber }));
        },
        [dispatch, filters],
    );

    useEffect(() => {
        if (positionTab === state.tab) {
            if (fromOtherPage || fromCreditBillsPage) {
                const filterByTab = {
                    ...initialFilters,
                    ...filterByTabList[positionTab],
                    billTab: tabOption,
                };
                dispatch(creditBillActions.setCreditBillFilters(filterByTab));
                dispatch(creditBillActions.getCreditBills(filterByTab));
            }
        }
    }, [state.tab]);

    useEffect(() => {
        const statesWithBills = creditBillList.reduce((stateWithBill, { saldoAceptado, estadoFactura, moneda }) => {
            if (!stateWithBill[estadoFactura]) {
                // eslint-disable-next-line no-param-reassign
                stateWithBill[estadoFactura] = [];
            }
            stateWithBill[estadoFactura].push({ saldoAceptado, estadoFactura, moneda });

            return stateWithBill;
        }, {});

        const billsByState = Object.values(statesWithBills).map((billList) => {
            const summaryBillByState = billList.reduce(
                (sum, bill) => ({
                    quantity: billList.length,
                    status: bill.estadoFactura,
                    totalAmount: sum.totalAmount + bill.saldoAceptado,
                    currency: monedas[bill.moneda],
                }),
                { totalAmount: 0 },
            );
            return summaryBillByState;
        });
        setSummaryData(billsByState);
    }, [creditBillList]);

    return { filters, fetchMoreBills, summaryData, fetching };
};

export default useBills;
